module.exports = __webpack_public_path__ + "public/Icons/mainSite.svg?2068ca0f";